export { default } from './RibbonBlank'
